export const inventorySummary = async (org) => {
  return {
    AccountSummary: org.AccountSummary,
    RegionSummary: org.RegionSummary || [],
    ResourceSummary: org.ResourceSummary || [],
  };
};

export const inventorySummaryByAccount = async (org) => {
  return org.AccountSummary;
};

export const inventorySummaryByRegion = async (org) => {
  return org.RegionSummary || [];
};

export const inventorySummaryByResource = async (org) => {
  return org.ResourceSummary || [];
};

export const governanceSummary = async (instance) => {
  const umanaged = instance.filter((instance) => !instance.IsDay2Managed);
  return [
    { Label: "New", Value: 0 },
    { Label: "Unmanaged", Value: umanaged.length },
    { Label: "Untagged", Value: 89 },
  ];
};

export const azureGovernanceSummary = async () => {
  return [{ Label: "New", Value: 20 }];
};
